//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "result",
    data() {
        return {
            lang: '',
            code: null,
        }
    },
    methods: {
        close(){
            window.location.href = 'cmcchkh5action://close'
        }
    },
    mounted() {
    },
    created() {
        this.code = parseInt(this.$route.query.code)
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/activity5G/result.vue